import { toast, ToastPosition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const success = (parameter: string, position?: ToastPosition | undefined) => {
  toast.success(parameter, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export const warn = (parameter: string, position?: ToastPosition | undefined) => {
  toast.warn(parameter, {
    position: (position || "top-right"),
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export const error = (parameter: string, position?: ToastPosition | undefined) => {
  toast.error(parameter, {
    position: (position || "top-right"),
    autoClose: 10000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export const info = (parameter: string, position?: ToastPosition | undefined) => {
  toast.info(parameter, {
    position: (position || "top-right"),
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}